import { LoadingArea } from "@/components/elements/Loading/Loading";
import { EMPTY_STR } from "@/constants/string";
import { useChat } from "@/features/chat/providers/ChatProvider";
import { primary } from "@/theme/colors";
import { openInNewTab } from "@/utils/export";
import { createUrlWithParams } from "@/utils/url";
import { Stack, styled, Typography } from "@mui/material";
import { truncateWithEllipsis } from "@/utils/string";
import { formatCompanyId, formatRSOId, formatSupportId } from "@/utils/number";
import { USER_TYPE } from "@/types/enum";
import { TGetUserOutputDto } from "@/api/services/admin/conversation/dtos/get-conversation.dto";

const getCreatorOwnerId = (creator?: TGetUserOutputDto): string => {
  if (!creator) return "";
  switch (creator.type) {
    case USER_TYPE.RSO_USER:
      return creator.rso?.id ? formatRSOId(creator.rso.id) : "";
    case USER_TYPE.COMPANY_USER:
      return creator.company?.id ? formatCompanyId(creator.company.id) : "";
    case USER_TYPE.SUPPORT_USER:
      return creator.company?.id ? formatSupportId(creator.company.id) : "";
    default:
      return "";
  }
};

export const RoomHead = () => {
  const { currentRoom } = useChat();

  if (!currentRoom.roomData)
    return (
      <StyledRoomHead height={118}>
        <LoadingArea />
      </StyledRoomHead>
    );

  const creator = currentRoom.roomData.creator;
  const ownerId = getCreatorOwnerId(creator);

  return (
    <StyledRoomHead>
      <Typography sx={{ marginBottom: "4px" }} variant="sub16Bold">
        {truncateWithEllipsis(creator?.fullName ?? EMPTY_STR.TEXT, 30)}
      </Typography>
      <Typography
        variant="body14"
        sx={{
          textDecoration: "underline",
          "&:hover": {
            cursor: "pointer",
            opacity: 0.8,
          },
        }}
        onClick={() => {
          const url = process.env.REACT_APP_FRONTEND_MAIN_ROOT_URL;
          return openInNewTab(`${createUrlWithParams(`${url}/login`, { ownerId })}`);
        }}
      >
        {truncateWithEllipsis(
          currentRoom?.roomData?.creator?.rso?.name ?? currentRoom?.roomData?.creator?.company?.companyName ?? EMPTY_STR.TEXT,
          30,
        )}
        ・ID: {ownerId}
      </Typography>
    </StyledRoomHead>
  );
};

const StyledRoomHead = styled(Stack)`
  padding: 24px 16px;
  border-radius: 8px;
  background-color: ${primary.main};
  color: white;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;
